var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$_collector && _vm.$_collector.type == 24)?_c('RemotePanel'):(_vm.$_collector)?_c('OwnPanel'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }